import { Component, signal, computed, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NgxSpinnerModule } from 'ngx-spinner';
import { HeaderComponent } from './shared/widget/header/header';
import { FooterComponent } from './shared/widget/footer/footer';
import { AuthService } from './_core/services/auth.service';
import { HasRoleDirective } from './_core/directives/has-role.directive';
import { environment } from '../environments/environment';
import { BUILD_TIME } from '../environments/build-info';
@Component({
  selector: 'app-root',
  imports: [RouterOutlet, NgxSpinnerModule, HeaderComponent, FooterComponent, NgxSpinnerModule],
  templateUrl: './app.html',
  standalone: true,
  styles: [`
    .env-banner {
      position: sticky;
      top: 0;
      z-index: 2000;
      padding: 4px 12px;
      background: #6c757d;
      color: #fff;
      font-size: 12px;
      font-weight: 700;
      letter-spacing: 2px;
      text-align: center;
      text-transform: uppercase;
    }
    .env-banner--staging {
      background: repeating-linear-gradient(45deg, #d97706, #d97706 12px, #b45309 12px, #b45309 24px);
    }
  `],
})
export class App {
  // Marcatore di ambiente: usa envName, NON environment.production
  // (production e' true anche in staging, intenzionalmente).
  protected readonly envName = environment.envName;
  protected readonly envBanner = environment.envName === 'production'
    ? ''
    : `${environment.envName}${App.formatBuildTime(BUILD_TIME)}`;

  private static formatBuildTime(iso: string): string {
    if (!iso) {
      return '';
    }
    const formatted = new Date(iso).toLocaleString('it-IT', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
    return ` — build ${formatted}`;
  }

  async ngOnInit() {

    //const jwtRole = await this.auth.getRole();

    //this.role.set(jwtRole ?? 'guest');
  }
  private auth = inject(AuthService);
  protected readonly title = signal('M4N');
}
